const tech_stack = [
  { name: "JavaScript" },
  { name: "HTML5" },
  { name: "Ajax" },
  { name: "Sass" },
  { name: "React" },
  { name: "TypeScript" },
  { name: "React Native" },
  { name: "Storybook" },
  { name: "Ruby on Rails" },
  { name: "PostgreSQL" },
  { name: "JQuery" },
  { name: "Cypress" },
  { name: "Node" },
  { name: "MongoDB" },
  { name: "CSS" },
  { name: "Jest" },
  { name: "Express" },
  { name: "MySQL" },
  { name: "Python" },
  { name: "Chai/Mocha" },
];

export default tech_stack;